import React from "react";
import { Card, CardHeader, CardBody, Col, Row } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};


const Tile = ({ title, value }) => (
  <div
    style={{
      border: "1px solid rgba(255,255,255,0.06)",
      borderRadius: "8px",
      padding: "20px",
      textAlign: "center",
    }}
  >
    <p className="text-muted mb-1">{title}</p>
    <h4 className="mb-0">{value}</h4>
  </div>
);

const AssetSecurityPosture = () => {
  return (

    <Card style={{ ...cardShell, border: "1px solid rgba(255,255,255,0.05)" }} className="h-100">

      <CardHeader className="bg-light d-flex align-items-center">
        <h5 className="card-title mb-0">
          <div style={pageIconWrapStyle} className="me-2">
            <i className="ri-database-2-line " style={pageIconStyle} ></i>
          </div>
          OT ASSET SECURITY POSTURE
        </h5>
      </CardHeader>

      <CardBody>

        <Row className="g-3">

          <Col md={6}>
            <Tile title="TOTAL OT ASSETS" value="1,422" />
          </Col>

          <Col md={6}>
            <Tile title="UNIDENTIFIED DEVICES" value="12" />
          </Col>

          <Col md={6}>
            <Tile title="DEFAULT CREDENTIALS" value="45" />
          </Col>

          <Col md={6}>
            <Tile title="OPEN MANAGEMENT PORTS" value="89" />
          </Col>

        </Row>

      </CardBody>
    </Card>

  );
};

export default AssetSecurityPosture;